import { triggerAnalyticsEvent } from 'syf-js-utilities';
const triggerManageCardHoldersSamsAnalytics = (params) => triggerAnalyticsEvent({
    pageFunction: 'auth user',
    pageKind: 'account services',
    ...params
});
export default triggerManageCardHoldersSamsAnalytics;
